import React from 'react'
import { FormGroup, Label } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import { OptionTypeBase, ValueType } from 'react-select'
import { fetchAndHandleProductUser } from 'store/css-admin/userManager/operations'
import lmsOperations from 'store/css-admin/lmsManager/operations'
import ErrorBoundary from 'components/ErrorBoundary'
import Loading from 'components/Loading/Loading'
import SelectLookup from 'components/SelectLookup'
import { formatUserSuggestion } from 'lib/util'
import { RootState } from 'types'

type UserSuggestion = OptionTypeBase & {
  email: string
  id: number
  firstName?: string
  lastName?: string
}

const UserSearch: React.FC = () => {
  const dispatch = useDispatch()
  const isLoading = useSelector(
    (state: RootState) => state.userManager.isLoading,
  )

  const handleUserSelect = (value: ValueType<OptionTypeBase>) => {
    const user = value as UserSuggestion | null
    if (!user) return

    dispatch(fetchAndHandleProductUser(user.email, user.id.toString()))
    dispatch(lmsOperations.fetchTrainingStatusesCss(user.email))
  }

  return (
    <>
      <h2>User Search</h2>
      <hr />
      <ErrorBoundary>
        <Loading isLoading={isLoading} />
        <FormGroup>
          <Label>Email</Label>
          <SelectLookup
            apiVersion={2}
            formatSuggestion={formatUserSuggestion}
            onChange={handleUserSelect}
            placeholder="Email"
            searchEndpoint="profile/search"
            searchField="email"
          />
        </FormGroup>
      </ErrorBoundary>
    </>
  )
}

export default UserSearch
